import './src/styles/global.css';

const googleTagManagerId = 'GTM-K6LKHQH';

const hasAnalyticsConsent = () => {
    if (typeof document === 'undefined') {
        return false;
    }

    const cookieMatch = document.cookie.match(/(?:^|;\s*)CookiesConsent=([^;]+)/);

    if (!cookieMatch) {
        return false;
    }

    try {
        const value = decodeURIComponent(cookieMatch[1]);
        const parsedValue = JSON.parse(value.startsWith('j:') ? value.slice(2) : value);

        return parsedValue?.performanceAndAnalytics === true;
    } catch {
        return false;
    }
};

const initializeGoogleTagManager = () => {
    if (typeof document === 'undefined' || document.getElementById('google-tag-manager')) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': Date.now(),
        event: 'gtm.js'
    });

    const script = document.createElement('script');
    script.id = 'google-tag-manager';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${googleTagManagerId}`;
    document.head.appendChild(script);
};

const onRouteUpdate = ({ location }) => {
    if (!hasAnalyticsConsent()) {
        return null;
    }

    initializeGoogleTagManager();

    const path = location ? `${location.pathname}${location.search}${location.hash}` : undefined;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'gatsby-route-change',
        pagePath: path
    });

    const _hsq = (window._hsq = window._hsq || []);

    const trackPageView = () => {
        _hsq.push(['setPath', path]);
        _hsq.push(['trackPageView']);
    };

    setTimeout(trackPageView, 32);

    return null;
};

export { onRouteUpdate };
